<div class="flex flex-col gap-[15px]">
  <ng-container *ngIf="mostrarSeccion">
    <span *ngIf="titulo" class="titulo !text-2xl">{{tituloReflejado.tituloOpcional ? tituloReflejado.tituloOpcional : titulo}}</span>
  <nav mat-tab-nav-bar class="border-b" [tabPanel]="tabPanel" [mat-stretch-tabs]="false" [ngStyle]="{'border-bottom-style': (showBottomLine ? 'solid' : 'none')}">
    <a class="tabsSubTemas"
      mat-tab-link
      *ngFor="let link of links"
      (click)="activeTab = link.url; tituloReflejado = link"
      routerLink="{{ link.url }}"
      [active]="activeTab == link.url"
    >
      {{ link.title }}
    </a>
  </nav>
  </ng-container>
  
</div>
<mat-tab-nav-panel #tabPanel> </mat-tab-nav-panel>